// src/views/contasBancarias/ContasBancariasList.jsx
import TransferenciaModal from "../../components/ui/TransferenciaModal";
import React, { useState, useEffect, useCallback, useRef } from "react";
import contasBancariasService from "../../services/contasBancariasService";
import transacoesService from "../../services/transacoesService";
import condominiosService from "../../services/condominiosService";
import { useAuth } from "../../contexts/AuthContext";
import ContaBancariaModal from "./ContaBancariaModal";
import TransacaoModal from "./TransacaoModal";
import DeleteModal from "../../components/ui/DeleteModal";
import Banner from "../../components/ui/Banner";
import ConfirmModal from "../../components/ui/ConfirmModal";
import { getApiBaseUrl } from "../../services/apiBase";

const fmtMoeda = v => v!=null ? Number(v).toLocaleString("pt-BR",{style:"currency",currency:"BRL"}) : "—";
const fmtDt    = dt => { if(!dt) return "-"; try{ return new Date((String(dt||"").split("T")[0])+"T12:00:00").toLocaleDateString("pt-BR"); } catch{ return dt; } };

// Dias desde uma data ISO até hoje (ou "—")
const diasDesde = (dt) => {
  if (!dt) return null;
  try {
    const d = new Date(String(dt).split("T")[0] + "T12:00:00");
    return Math.floor((Date.now() - d.getTime()) / (1000*60*60*24));
  } catch { return null; }
};

const STATUS_STYLE = {
  Pendente:    {background:"var(--bg-warning-soft)",color:"#854D0E"},
  Confirmado:  {background:"var(--bg-highlight)",color:"#1E40AF"},
  Conciliado:  {background:"var(--bg-success-soft)",color:"#166534"},
  Cancelado:   {background:"var(--bg-danger-soft)",color:"#991B1B"},
  Estornada:   {background:"#FED7AA",color:"#9A3412"},
};

export default function ContasBancariasList() {
  const { condominioAtivo, isAdmin, isGerente } = useAuth();
  const prevIdCondo = React.useRef("");
  const { podeEditar } = useAuth();
  const canEdit = podeEditar("contasBancarias");
  const [condominios, setCondominios]   = useState([]);

  // Sync with navbar condominioAtivo — updates whenever user changes it
  useEffect(() => {
    if (condominioAtivo?.id) setIdCondo(String(condominioAtivo.id));
    else setIdCondo("");
    setContaSelecionada(null); // reset selected conta when condo changes
  }, [condominioAtivo]);
  const [idCondo, setIdCondo]           = useState("");
  const [contas, setContas]             = useState([]);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [aba, setAba]                   = useState("contas"); // contas | extrato | conciliacao | cnab | api
  const [apiConfig, setApiConfig]       = useState({clientId:"",clientSecret:"",ambiente:"Homologacao",agencia:"",conta:"",numeroContrato:"",modalidade:1,banco:"Sicoob",chavePix:"",urlApiHomologacao:"",urlApiProducao:""});
  const [apiTestedMsg, setApiTestedMsg] = useState("");
  const [apiTested, setApiTested]        = useState(null); // null | "ok" | "erro"
  const [salvandoApi, setSalvandoApi]   = useState(false);
  // Contas
  const [showContaModal, setShowContaModal] = useState(false);
  const [showTransf,     setShowTransf]     = useState(false);
  const [editConta, setEditConta]       = useState(null);
  const [showDeleteConta, setShowDeleteConta] = useState(false);
  const [deleteConta, setDeleteConta]   = useState(null);
  const [savingConta, setSavingConta]   = useState(false);
  const [deletingConta, setDeletingConta] = useState(false);
  // Transações
  const [transacoes, setTransacoes]     = useState([]);
  const [totais, setTotais]             = useState({creditos:0,debitos:0,saldo:0});
  const [paginacao, setPaginacao]       = useState({total:0,totalPages:1});
  const [loadingTrans, setLoadingTrans] = useState(false);
  const [filtros, setFiltros]           = useState({ dtInicio:"", dtFim:"", status:"", origem:"", tpMovimento:"", page:1 });
  const [showTransModal, setShowTransModal] = useState(false);
  const [editTrans, setEditTrans]       = useState(null);
  const [savingTrans, setSavingTrans]   = useState(false);
  // Conciliação manual
  const [naoConciliadas, setNaoConciliadas] = useState([]);
  const [selecionadas, setSelecionadas]  = useState([]);
  const [dtConciliacao, setDtConciliacao] = useState(new Date().toISOString().split("T")[0]);
  const [conciliando, setConciliando]   = useState(false);
  const [filtroConc, setFiltroConc]     = useState({ busca:"", origem:"", tpMov:"" });
  // Webhook health
  const [webhookHealth, setWebhookHealth] = useState(null);
  // Revogar credenciais
  const [revogando, setRevogando]       = useState(false);

  // Banner global de feedback
  const [banner, setBanner] = useState(null);
  const showBanner = (tipo, msg) => { setBanner({ tipo, msg }); setTimeout(()=>setBanner(null), 7000); };

  // Confirmações via ConfirmModal (substitui window.confirm)
  const [confirmacao, setConfirmacao] = useState(null);
  // formato: { titulo, mensagem, perigo, textoOk, onConfirm }
  const abrirConfirmacao = (cfg) => setConfirmacao(cfg);
  // CNAB
  const [cnabTipo, setCnabTipo]         = useState("CNAB240");
  const [cnabConteudo, setCnabConteudo] = useState("");
  const [cnabNome, setCnabNome]         = useState("");
  const [importando, setImportando]     = useState(false);
  const [resultCnab, setResultCnab]     = useState(null);
  const fileRef = useRef();

  // Carrega condomínios
  useEffect(() => {
    condominiosService.listar({ limit:100 }).then(r => {
      setCondominios(r.data);

    }).catch(()=>{});
  }, []);

  // Carrega contas do condomínio

  // Load API config when conta changes
  useEffect(() => {
    if (!contaSelecionada?.id) return;
    contasBancariasService.buscarApiConfig(contaSelecionada.id)
      .then(r => { if (r?.data) setApiConfig({clientId:"",clientSecret:"",ambiente:"Homologacao",agencia:"",conta:"",numeroContrato:"",modalidade:1,banco:"Sicoob",chavePix:"",urlApiHomologacao:"",urlApiProducao:"",...r.data}); })
      .catch(()=>{});
  }, [contaSelecionada?.id]);
  const carregarContas = useCallback(async () => {
    if(!idCondo) return;
    try {
      const r = await contasBancariasService.listar({ idCondominio:idCondo });
      setContas(r.data);
      // Auto-select first conta when condo changes, keep selection on refresh
      if (prevIdCondo.current !== idCondo) {
        setContaSelecionada(r.data.length > 0 ? r.data[0] : null);
        prevIdCondo.current = idCondo;
      } else {
        // On refresh: update saldo of currently selected conta
        setContaSelecionada(prev => {
          if (!prev) return r.data.length > 0 ? r.data[0] : null;
          return r.data.find(ct => ct.id === prev.id) || (r.data.length > 0 ? r.data[0] : null);
        });
      }
    } catch(e) { console.error(e); }
  }, [idCondo]);

  useEffect(() => { carregarContas(); }, [carregarContas]);

  // Carrega transações da conta selecionada
  const carregarTransacoes = useCallback(async () => {
    if(!contaSelecionada?.id) return;
    setLoadingTrans(true);
    try {
      const r = await transacoesService.listar({ idContaBancaria:contaSelecionada.id, ...filtros, limit:20 });
      setTransacoes(r.data); setTotais(r.totais); setPaginacao(r.pagination);
    } catch(e) { console.error(e); }
    setLoadingTrans(false);
  }, [contaSelecionada, filtros]);

  useEffect(() => { if(aba==="extrato") carregarTransacoes(); }, [carregarTransacoes, aba]);

  // Carrega não conciliadas
  const carregarNaoConciliadas = useCallback(async () => {
    if(!contaSelecionada?.id) return;
    try {
      const r = await transacoesService.naoConciliadas(contaSelecionada.id);
      setNaoConciliadas(r.data); setSelecionadas([]);
    } catch(e) {}
  }, [contaSelecionada]);

  useEffect(() => { if(aba==="conciliacao") carregarNaoConciliadas(); }, [carregarNaoConciliadas, aba]);
  useEffect(() => {
    if (aba === "api" && contaSelecionada?.id) {
      // Carrega config da tabela canônica (contas_bancarias_api). NÃO mistura
      // com a config do boleto (contas_bancarias_boleto) — são telas distintas.
      contasBancariasService.buscarApiConfig(contaSelecionada.id)
        .then(r=>{ if(r?.data) setApiConfig(prev=>({...prev,...r.data,clientSecret:""})); })
        .catch(()=>{});
      contasBancariasService.webhookHealth(contaSelecionada.id)
        .then(r=> setWebhookHealth(r?.data || null))
        .catch(()=>{});
    }
  }, [aba, contaSelecionada]);

  // Lista filtrada de transações para conciliação
  const naoConciliadasFiltradas = naoConciliadas.filter(t => {
    const b = filtroConc.busca.trim().toLowerCase();
    if (b && !(`${t.historico||""}`.toLowerCase().includes(b) || `${t.sacado||""}`.toLowerCase().includes(b))) return false;
    if (filtroConc.origem && t.origem !== filtroConc.origem) return false;
    if (filtroConc.tpMov && t.tpMovimento !== filtroConc.tpMov) return false;
    return true;
  });
  const origensConc = [...new Set(naoConciliadas.map(t => t.origem).filter(Boolean))];

  const condoNome = condominios.find(c=>String(c.id)===String(idCondo))?.nmFantasia||"";

  // Ações conta
  const handleSaveConta = async (form) => {
    setSavingConta(true);
    try {
      const payload = {...form, idCondominio:idCondo};
      if(form.id) await contasBancariasService.atualizar(form.id, payload);
      else        await contasBancariasService.criar(payload);
      setShowContaModal(false);
      showBanner("success", form.id ? "Conta bancária atualizada." : "Conta bancária criada.");
      await carregarContas();
    } catch(e) { showBanner("error", e.message || "Erro ao salvar conta."); }
    setSavingConta(false);
  };

  const handleDeleteConta = async () => {
    setDeletingConta(true);
    try {
      await contasBancariasService.deletar(deleteConta.id);
      setShowDeleteConta(false);
      if(contaSelecionada?.id===deleteConta.id) setContaSelecionada(null);
      const nm = deleteConta.nmConta;
      setDeleteConta(null);
      showBanner("success", `Conta "${nm}" excluída.`);
      await carregarContas();
    } catch(e) {
      // Mensagem rica quando o backend retorna vínculos (409)
      const msg = e?.message || "Erro ao excluir conta.";
      if (msg.toLowerCase().includes("possui") || msg.toLowerCase().includes("inative")) {
        const conta = deleteConta;
        abrirConfirmacao({
          titulo: "Conta possui vínculos",
          mensagem: `${msg}\n\nDeseja inativar a conta agora? (ela ficará marcada como inativa e fora dos filtros padrão)`,
          textoOk: "Inativar conta",
          perigo: false,
          onConfirm: async () => {
            try {
              await contasBancariasService.atualizar(conta.id, { situacao: "inativo" });
              setShowDeleteConta(false); setDeleteConta(null); setConfirmacao(null);
              showBanner("success", `Conta "${conta.nmConta}" inativada.`);
              await carregarContas();
            } catch(e2) { setConfirmacao(null); showBanner("error", e2?.message || "Erro ao inativar."); }
          },
        });
      } else {
        showBanner("error", msg);
      }
    }
    setDeletingConta(false);
  };

  // Ações transação
  const handleSaveTrans = async (form) => {
    setSavingTrans(true);
    try {
      const payload = {...form, idContaBancaria:contaSelecionada.id};
      if(form.id) await transacoesService.atualizar(form.id, payload);
      else        await transacoesService.criar(payload);
      setShowTransModal(false);
      showBanner("success", form.id ? "Transação atualizada." : "Transação registrada.");
      await carregarTransacoes(); await carregarContas();
    } catch(e) { showBanner("error", e.message || "Erro ao salvar transação."); }
    setSavingTrans(false);
  };

  const handleConfirmar = async (id) => {
    try { await transacoesService.confirmar(id); showBanner("success","Transação confirmada."); await carregarTransacoes(); }
    catch(e) { showBanner("error", e.message); }
  };
  const handleCancelar = (id) => {
    abrirConfirmacao({
      titulo: "Cancelar transação",
      mensagem: "A transação será marcada como cancelada e o saldo será recalculado. Deseja continuar?",
      textoOk: "Cancelar transação",
      perigo: true,
      onConfirm: async () => {
        try {
          await transacoesService.cancelar(id);
          setConfirmacao(null);
          showBanner("success", "Transação cancelada.");
          await carregarTransacoes(); await carregarContas();
        } catch(e) { setConfirmacao(null); showBanner("error", e.message); }
      },
    });
  };
  const handleConciliarUm = async (id) => {
    try { await transacoesService.conciliar(id, dtConciliacao); showBanner("success","Transação conciliada."); await carregarTransacoes(); }
    catch(e) { showBanner("error", e.message); }
  };

  // Conciliação em lote
  const toggleSelecionada = (id) => setSelecionadas(p => p.includes(id) ? p.filter(x=>x!==id) : [...p,id]);
  const toggleTodas = () => setSelecionadas(selecionadas.length===naoConciliadas.length ? [] : naoConciliadas.map(t=>t.id));
  const handleConciliarLote = () => {
    if(!selecionadas.length) return showBanner("warning","Selecione ao menos uma transação.");
    if(!dtConciliacao) return showBanner("warning","Informe a data de conciliação.");
    abrirConfirmacao({
      titulo: "Conciliação em lote",
      mensagem: `Confirma a conciliação de ${selecionadas.length} transação(ões) na data ${dtConciliacao}?`,
      textoOk: "Conciliar",
      perigo: false,
      onConfirm: async () => {
        setConciliando(true);
        try {
          const r = await transacoesService.conciliarLote(selecionadas, dtConciliacao);
          setConfirmacao(null);
          showBanner("success", r?.message || `${selecionadas.length} transação(ões) conciliada(s).`);
          await carregarNaoConciliadas(); await carregarContas();
        } catch(e) { setConfirmacao(null); showBanner("error", e.message); }
        setConciliando(false);
      },
    });
  };

  // CNAB
  const handleArquivoCNAB = (e) => {
    const file = e.target.files[0]; if(!file) return;
    setCnabNome(file.name);
    const reader = new FileReader();
    reader.onload = (ev) => setCnabConteudo(ev.target.result);
    reader.readAsText(file, "latin1");
  };

  const handleImportarCNAB = async () => {
    if(!contaSelecionada?.id) return showBanner("warning","Selecione uma conta.");
    if(!cnabConteudo)         return showBanner("warning","Selecione o arquivo CNAB.");
    setImportando(true); setResultCnab(null);
    try {
      const r = await transacoesService.importarCNAB({ idContaBancaria:contaSelecionada.id, nmArquivo:cnabNome, tpArquivo:cnabTipo, conteudo:cnabConteudo });
      setResultCnab(r);
      showBanner("success", r?.message || "Importação concluída.");
      await carregarContas();
    } catch(e) { showBanner("error", e.message); }
    setImportando(false);
  };

  const setF = (f,v) => setFiltros(p=>({...p,[f]:v,page:1}));

  return (
    <div>
      {/* Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title"><i className="bi bi-bank me-2" style={{color:"var(--primary)",fontSize:22}}/>Contas Bancárias</h1>
          <p className="page-subtitle">Gerencie contas, transações e conciliação bancária</p>
        </div>
        <div className="d-flex gap-2 flex-wrap align-items-center">

        </div>
      </div>

      {banner && (
        <Banner tipo={banner.tipo} onClose={()=>setBanner(null)}>
          {banner.msg}
        </Banner>
      )}

      {/* Layout: sidebar contas + conteúdo */}
      <div style={{display:"flex",gap:16,alignItems:"flex-start"}}>

        {/* Sidebar de contas */}
        <div style={{width:260,flexShrink:0}}>
          <div className="card">
            <div style={{padding:"12px 16px",borderBottom:"1px solid var(--gray-100)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span style={{fontSize:13,fontWeight:600,color:"var(--gray-700)"}}>Contas</span>
              <button className="btn btn-primary btn-sm" onClick={()=>{ setEditConta(null); setShowContaModal(true); }} disabled={!idCondo} style={{fontSize:12}}>
                <i className="bi bi-plus-lg"/>
              </button>
            </div>
            {contas.length===0
              ? <div style={{padding:"24px 16px",textAlign:"center",color:"var(--gray-400)",fontSize:13}}>{idCondo?"Nenhuma conta":"Selecione um condomínio"}</div>
              : contas.map(c=>{
                const diasUltConc = diasDesde(c.ultimaConciliacao);
                const pendentes   = Number(c.qtdNaoConciliadas || 0);
                const boletosAb   = Number(c.qtdBoletosAbertos || 0);
                return (
                <div key={c.id}
                  onClick={()=>{ setContaSelecionada(c); setAba("extrato"); }}
                  style={{padding:"12px 16px",cursor:"pointer",borderBottom:"1px solid var(--gray-100)",
                    background:contaSelecionada?.id===c.id?"#EFF6FF":"#fff",
                    borderLeft:contaSelecionada?.id===c.id?"3px solid var(--primary)":"3px solid transparent"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:6}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:600,fontSize:13,color:"var(--gray-800)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.nmConta}</div>
                      <div style={{fontSize:11,color:"var(--gray-400)"}}>{c.banco||c.tpConta}</div>
                    </div>
                    <div style={{textAlign:"right",flexShrink:0}}>
                      <div style={{fontSize:13,fontWeight:700,color:Number(c.saldoAtual)>=0?"#166534":"#991B1B"}}>{fmtMoeda(c.saldoAtual)}</div>
                      <span style={{background:c.situacao==="ativo"?"#DCFCE7":"#FEE2E2",color:c.situacao==="ativo"?"#166534":"#991B1B",padding:"1px 6px",borderRadius:8,fontSize:10,fontWeight:600}}>{c.situacao==="ativo"?"Ativa":"Inativa"}</span>
                    </div>
                  </div>
                  {(pendentes>0 || boletosAb>0 || diasUltConc !== null) && (
                    <div style={{display:"flex",gap:6,marginTop:6,flexWrap:"wrap",fontSize:10}}>
                      {pendentes>0 && (
                        <span style={{background:"#FEF3C7",color:"#92400E",padding:"1px 6px",borderRadius:8,fontWeight:600}} title="Transações pendentes de conciliação">
                          <i className="bi bi-clock-history me-1"/>{pendentes} pendente{pendentes!==1?"s":""}
                        </span>
                      )}
                      {boletosAb>0 && (
                        <span style={{background:"var(--bg-highlight)",color:"#1E40AF",padding:"1px 6px",borderRadius:8,fontWeight:600}} title="Boletos em aberto">
                          <i className="bi bi-receipt me-1"/>{boletosAb} boleto{boletosAb!==1?"s":""}
                        </span>
                      )}
                      {diasUltConc !== null && (
                        <span style={{background:diasUltConc>30?"#FEE2E2":"#F1F5F9",color:diasUltConc>30?"#991B1B":"var(--gray-600)",padding:"1px 6px",borderRadius:8,fontWeight:600}}
                          title={`Última conciliação: ${fmtDt(c.ultimaConciliacao)}`}>
                          <i className="bi bi-check2-circle me-1"/>{diasUltConc===0?"hoje":`há ${diasUltConc}d`}
                        </span>
                      )}
                    </div>
                  )}
                  {contaSelecionada?.id===c.id&&(
                    <div style={{display:"flex",gap:4,marginTop:6}}>
                      <button className="btn btn-outline-secondary btn-sm" style={{fontSize:11,padding:"2px 6px"}} onClick={e=>{e.stopPropagation();setEditConta(c);setShowContaModal(true);}}>
                        <i className="bi bi-pencil"/>
                      </button>
                      <button className="btn btn-outline-danger btn-sm" style={{fontSize:11,padding:"2px 6px"}} onClick={e=>{e.stopPropagation();setDeleteConta(c);setShowDeleteConta(true);}} disabled={!canEdit}>
                        <i className="bi bi-trash3"/>
                      </button>
                    </div>
                  )}
                </div>
                );
              })
            }
          </div>
        </div>

        {/* Conteúdo principal */}
        <div style={{flex:1,minWidth:0}}>
          {!contaSelecionada
            ? <div style={{textAlign:"center",padding:"80px 0",color:"var(--gray-400)"}}>
                <i className="bi bi-bank" style={{fontSize:48,display:"block",marginBottom:12}}/>
                <p style={{fontSize:16,fontWeight:500}}>Selecione uma conta</p>
              </div>
            : <>
                {/* Stats da conta */}
                <div className="row g-3 mb-3">
                  {[
                    {icon:"bi-wallet2",      cls:"blue",  val:fmtMoeda(contaSelecionada.saldoAtual),  label:"Saldo Atual"},
                    {icon:"bi-arrow-down-circle", cls:"green", val:fmtMoeda(totais.creditos), label:"Total Créditos"},
                    {icon:"bi-arrow-up-circle",   cls:"orange",val:fmtMoeda(totais.debitos),  label:"Total Débitos"},
                    {icon:"bi-receipt",      cls:"gray",  val:paginacao.total,                         label:"Transações"},
                  ].map(s=>(
                    <div className="col-6 col-md-3" key={s.label}>
                      <div className="stat-card">
                        <div className={`stat-icon ${s.cls}`}><i className={`bi ${s.icon}`}/></div>
                        <div><div className="stat-value" style={{fontSize:16}}>{s.val}</div><div className="stat-label">{s.label}</div></div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Sub-abas */}
                <div className="card">
                  <div style={{borderBottom:"1px solid var(--gray-200)",padding:"0 16px",display:"flex",gap:4,overflowX:"auto"}}>
                    {[{id:"extrato",label:"Extrato / Transações",icon:"bi-list-ul"},{id:"conciliacao",label:"Conciliação Manual",icon:"bi-check2-all"},{id:"cnab",label:"Importar CNAB",icon:"bi-upload"},{id:"api",label:"Integração API",icon:"bi-plug"}].map(t=>(
                      <button key={t.id} className={`btn border-0 d-flex align-items-center gap-1 ${aba===t.id?"text-primary fw-600":""}`}
                        style={{fontSize:13,padding:"12px 14px",borderRadius:0,borderBottom:aba===t.id?"2px solid var(--primary)":"2px solid transparent",fontWeight:aba===t.id?600:400,color:aba===t.id?"var(--primary)":"var(--gray-500)",background:"transparent",whiteSpace:"nowrap"}}
                        onClick={()=>setAba(t.id)}>
                        <i className={`bi ${t.icon}`}/>{t.label}
                      </button>
                    ))}
                  </div>

                  {/* ── EXTRATO ── */}
                  {aba==="extrato"&&(
                    <>
                      <div style={{padding:"12px 16px",borderBottom:"1px solid var(--gray-100)",display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                        <input type="date" className="form-control form-control-sm" style={{width:"auto"}} value={filtros.dtInicio} onChange={e=>setF("dtInicio",e.target.value)} title="Data início"/>
                        <input type="date" className="form-control form-control-sm" style={{width:"auto"}} value={filtros.dtFim} onChange={e=>setF("dtFim",e.target.value)} title="Data fim"/>
                        <select className="form-select form-select-sm" style={{width:"auto"}} value={filtros.status} onChange={e=>setF("status",e.target.value)}>
                          <option value="">Todos status</option>
                          {["Pendente","Confirmado","Conciliado","Cancelado"].map(s=><option key={s}>{s}</option>)}
                        </select>
                        <select className="form-select form-select-sm" style={{width:"auto"}} value={filtros.tpMovimento} onChange={e=>setF("tpMovimento",e.target.value)}>
                          <option value="">Déb/Créd</option>
                          <option value="Credito">Crédito</option>
                          <option value="Debito">Débito</option>
                        </select>
                        <button className="btn btn-outline-secondary btn-sm" onClick={carregarTransacoes}><i className="bi bi-arrow-clockwise"/></button>
                        <button className="btn btn-outline-primary btn-sm" onClick={()=>setShowTransf(true)}>
                          <i className="bi bi-arrow-left-right me-1"/>Transferência
                        </button>
                        <button className="btn btn-primary btn-sm ms-auto" onClick={()=>{ setEditTrans(null); setShowTransModal(true); }}>
                          <i className="bi bi-plus-lg"/> Nova Transação
                        </button>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-custom">
                          <thead><tr><th>Data</th><th>Histórico</th><th>Origem</th><th>Documento</th><th>Sacado</th><th style={{textAlign:"right"}}>Valor</th><th style={{textAlign:"right"}}>Saldo</th><th>Status</th><th style={{width:110}}>Ações</th></tr></thead>
                          <tbody>
                            {loadingTrans?<tr><td colSpan={9} className="text-center py-4"><span className="spinner-border spinner-border-sm text-primary me-2"/></td></tr>
                            :transacoes.length===0?<tr><td colSpan={9} className="text-center py-4" style={{color:"var(--gray-400)"}}>Nenhuma transação</td></tr>
                            :transacoes.map(t=>(
                              <tr key={t.id}>
                                <td style={{fontSize:12.5,whiteSpace:"nowrap"}}>{fmtDt(t.dtTransacao)}</td>
                                <td style={{fontSize:13,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.historico||"—"}</td>
                                <td><span style={{background:"var(--gray-100)",color:"var(--gray-600)",padding:"2px 7px",borderRadius:10,fontSize:11}}>{t.origem}</span></td>
                                <td style={{fontSize:12,color:"var(--gray-500)"}}>{t.nrDocumento||t.nossoNumero||"—"}</td>
                                <td style={{fontSize:12.5,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.sacado||"—"}</td>
                                <td style={{textAlign:"right",fontWeight:700,fontSize:13,color:t.tpMovimento==="Credito"?"#166534":"#991B1B",whiteSpace:"nowrap"}}>
                                  {t.tpMovimento==="Credito"?"+":"-"} {fmtMoeda(t.vlrTransacao)}
                                </td>
                                <td style={{textAlign:"right",fontSize:12,color:"var(--gray-500)",whiteSpace:"nowrap"}}>{t.saldoApos!=null?fmtMoeda(t.saldoApos):"—"}</td>
                                <td>
                                  <span style={{...STATUS_STYLE[t.status],padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>
                                    {t.status}
                                  </span>
                                </td>
                                <td>
                                  <div className="table-actions">
                                    {t.status==="Pendente"&&<button className="btn btn-outline-secondary btn-sm btn-icon" title="Confirmar" onClick={()=>handleConfirmar(t.id)}><i className="bi bi-check-lg"/></button>}
                                    {["Pendente","Confirmado"].includes(t.status)&&<button className="btn btn-outline-secondary btn-sm btn-icon" title="Editar" onClick={()=>{ setEditTrans(t); setShowTransModal(true); }}><i className="bi bi-pencil"/></button>}
                                    {t.status!=="Cancelado"&&t.status!=="Conciliado"&&<button className="btn btn-outline-danger btn-sm btn-icon" title="Cancelar" onClick={()=>handleCancelar(t.id)}><i className="bi bi-x-circle"/></button>}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {/* Paginação */}
                      {paginacao.totalPages>1&&(
                        <div className="pagination-wrapper">
                          <span className="pagination-info">{paginacao.total} registros</span>
                          <nav><ul className="pagination pagination-sm mb-0">
                            <li className={`page-item ${filtros.page===1?"disabled":""}`}><button className="page-link" onClick={()=>setF("page",filtros.page-1)}><i className="bi bi-chevron-left"/></button></li>
                            {Array.from({length:paginacao.totalPages},(_,i)=>(<li key={i+1} className={`page-item ${filtros.page===i+1?"active":""}`}><button className="page-link" onClick={()=>setF("page",i+1)}>{i+1}</button></li>))}
                            <li className={`page-item ${filtros.page===paginacao.totalPages?"disabled":""}`}><button className="page-link" onClick={()=>setF("page",filtros.page+1)}><i className="bi bi-chevron-right"/></button></li>
                          </ul></nav>
                        </div>
                      )}
                    </>
                  )}

                  {/* ── CONCILIAÇÃO MANUAL ── */}

                  {aba==="api"&&(
                    <div style={{padding:16}}>
                      {/* Banner info */}
                      <div style={{background:"linear-gradient(135deg,#1B3A6B,#2563EB)",borderRadius:12,padding:"16px 20px",marginBottom:16,color:"#fff",display:"flex",gap:16,alignItems:"flex-start"}}>
                        <div style={{fontSize:32,lineHeight:1}}>🏦</div>
                        <div>
                          <div style={{fontWeight:700,fontSize:15,marginBottom:4}}>
                              Integração API Bancária
                            </div>
                            <div style={{fontSize:12,opacity:.85}}>
                              Sicoob (756) ou EFÍ Bank/Gerencianet (364) — Boleto + PIX Dinâmico
                            </div>
                          {apiConfig.clientId && (
                            <span style={{marginTop:6,display:"inline-block",background:"#10B981",borderRadius:20,padding:"2px 10px",fontSize:11,fontWeight:600}}>
                              ✓ API configurada{apiConfig.clientSecretHint ? ` (segredo ${apiConfig.clientSecretHint}…)` : ""}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Aviso sobre dupla configuração */}
                      <div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12,color:"#9A3412"}}>
                        <i className="bi bi-info-circle me-2"/>
                        <strong>Atenção:</strong> esta tela configura a <strong>API bancária</strong> (autenticação OAuth para emitir/consultar boletos e PIX).
                        Para ajustar <strong>parâmetros do boleto</strong> (multa, juros, desconto, instruções, espécie de documento), abra a conta → aba <strong>"Config. Boleto"</strong>.
                      </div>

                      {/* Painel de saúde do Webhook */}
                      {webhookHealth && (
                        <div style={{background:"var(--bg-surface-alt)",border:"1px solid var(--gray-200)",borderRadius:8,padding:"10px 14px",marginBottom:16,fontSize:12.5,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
                          <div>
                            <strong>Webhook:</strong>{" "}
                            {webhookHealth.ultimaRecepcao
                              ? <>último ping em <strong>{fmtDt(webhookHealth.ultimaRecepcao)}</strong> · {webhookHealth.totais30d?.total || 0} nos últimos 30 dias ({webhookHealth.totais30d?.processados || 0} processados)</>
                              : <span style={{color:"#9A3412"}}>nenhum ping recebido ainda — confirme se a URL está cadastrada no portal do banco</span>}
                          </div>
                          <button className="btn btn-outline-secondary btn-sm" onClick={()=>{
                            contasBancariasService.webhookHealth(contaSelecionada.id).then(r=>setWebhookHealth(r?.data||null)).catch(()=>{});
                          }}>
                            <i className="bi bi-arrow-clockwise"/>
                          </button>
                        </div>
                      )}

                      {/* Status de teste */}
                      {apiTested==="ok" && (
                        <div style={{background:"var(--bg-success-soft)",border:"1px solid #86EFAC",borderRadius:8,padding:"10px 14px",marginBottom:14,color:"#166534",fontSize:13}}>
                          <i className="bi bi-check-circle-fill me-2"/>
                          {apiTestedMsg || (apiConfig.banco==="EFI"||apiConfig.banco==="364" ? "✅ Conexão com EFÍ Bank estabelecida com sucesso!" : "✅ Conexão com Sicoob estabelecida com sucesso!")}
                        </div>
                      )}
                      {apiTested==="erro" && (
                        <div style={{background:"var(--bg-danger-soft)",border:"1px solid #FCA5A5",borderRadius:8,padding:"10px 14px",marginBottom:14,color:"#991B1B",fontSize:13}}>
                          <i className="bi bi-x-circle-fill me-2"/>
                          {apiTestedMsg||"Falha na conexão. Verifique as credenciais e tente novamente."}
                        </div>
                      )}

                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label fw-semibold">Client ID <span className="required-mark">*</span></label>
                          <input className="form-control" value={apiConfig.clientId||""}
                            onChange={e=>{setApiConfig(p=>({...p,clientId:e.target.value}));setApiTested(null);}}
                            placeholder="Obtido no Developer Portal Sicoob"
                            autoComplete="off"/>
                          <small className="text-muted" style={{fontSize:11}}>Ex: sicoob-app-123456</small>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-semibold">
                            Client Secret {!apiConfig.clientSecretHint && <span className="required-mark">*</span>}
                          </label>
                          <input className="form-control" type="password" value={apiConfig.clientSecret||""}
                            onChange={e=>{setApiConfig(p=>({...p,clientSecret:e.target.value}));setApiTested(null);}}
                            placeholder={apiConfig.clientSecretHint ? `${apiConfig.clientSecretHint}●●●●●●●● (já cadastrado — deixe vazio para manter)` : "Obtido no Developer Portal"}
                            autoComplete="new-password"/>
                          {apiConfig.clientSecretHint && (
                            <small className="text-muted" style={{fontSize:11}}>
                              <i className="bi bi-shield-check me-1" style={{color:"#10B981"}}/>
                              Segredo já cadastrado e criptografado. Preencha apenas se quiser substituir.
                            </small>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold">Agência</label>
                          <input className="form-control" value={apiConfig.agencia||""}
                            onChange={e=>setApiConfig(p=>({...p,agencia:e.target.value}))}
                            placeholder="Ex: 3201" maxLength={4}/>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold">Conta Corrente</label>
                          <input className="form-control" value={apiConfig.conta||""}
                            onChange={e=>setApiConfig(p=>({...p,conta:e.target.value}))}
                            placeholder="Ex: 00012345"/>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold">Número do Contrato</label>
                          <input className="form-control" value={apiConfig.numeroContrato||""}
                            onChange={e=>setApiConfig(p=>({...p,numeroContrato:e.target.value}))}
                            placeholder="Ex: 100000"/>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold">Banco</label>
                          <select className="form-select" value={apiConfig.banco||"Sicoob"}
                            onChange={e=>setApiConfig(p=>({...p,banco:e.target.value}))}>
                            <option value="Sicoob">756 — Sicoob</option>
                            <option value="EFI">364 — EFÍ Bank</option>
                          </select>
                        </div>
                        <div className="col-md-3">
                          <label className="form-label fw-semibold">Ambiente</label>
                          <select className="form-select" value={apiConfig.ambiente||"Homologacao"}
                            onChange={e=>{setApiConfig(p=>({...p,ambiente:e.target.value}));setApiTested(null);}}>
                            <option value="Homologacao">🧪 Sandbox / Homologação</option>
                            <option value="Producao">🚀 Produção</option>
                          </select>
                        </div>
                        {(apiConfig.banco==="EFI"||apiConfig.banco==="364")&&(
                        <div className="col-md-6">
                          <label className="form-label fw-semibold">Chave PIX <span style={{color:"var(--gray-400)",fontSize:11}}>(PIX Dinâmico)</span></label>
                          <input className="form-control" value={apiConfig.chavePix||""}
                            onChange={e=>setApiConfig(p=>({...p,chavePix:e.target.value}))}
                            placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"/>
                        </div>
                        )}
                        <div className="col-12 d-flex gap-2 align-items-center flex-wrap">
                          <button className="btn btn-primary" disabled={salvandoApi}
                            onClick={async()=>{
                              if (!apiConfig.clientId) return showBanner("warning","Client ID é obrigatório.");
                              setSalvandoApi(true);
                              try {
                                await contasBancariasService.salvarApiConfig(contaSelecionada.id, apiConfig);
                                const nomeBanco = (apiConfig.banco==="EFI"||apiConfig.banco==="364") ? "EFÍ Bank" : "Sicoob";
                                showBanner("success", `Configuração API ${nomeBanco} salva com sucesso!`);
                                // Limpa o secret após salvar (apenas o hint fica)
                                setApiConfig(p=>({...p, clientSecret:""}));
                              } catch(e){ showBanner("error", e?.message||"Erro ao salvar."); }
                              setSalvandoApi(false);
                            }}>
                            {salvandoApi?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>
                              :<><i className="bi bi-save me-1"/>Salvar Configuração</>}
                          </button>
                          <button className="btn btn-outline-success"
                            disabled={(!apiConfig.clientId && !apiConfig.clientSecretHint)||salvandoApi}
                            onClick={async()=>{
                              setApiTested(null);
                              try {
                                const r = await fetch(`${getApiBaseUrl()}/contas-bancarias/${contaSelecionada.id}/api-config/testar`,{
                                  method:"POST",
                                  headers:{
                                    "Content-Type":"application/json",
                                    Authorization:`Bearer ${localStorage.getItem("accessToken")}`
                                  },
                                  body: JSON.stringify(apiConfig)
                                });
                                const d = await r.json();
                                setApiTested(d.success?"ok":"erro");
                                setApiTestedMsg(d.message||(d.success?"Conexão estabelecida com sucesso!":"Falha na conexão."));
                              } catch(e){ setApiTested("erro"); setApiTestedMsg(e.message||"Erro de rede."); }
                            }}>
                            <i className="bi bi-wifi me-1"/>Testar Conexão
                          </button>
                          {(apiConfig.clientId || apiConfig.clientSecretHint) && (
                            <button className="btn btn-outline-danger"
                              disabled={revogando||salvandoApi}
                              onClick={()=>abrirConfirmacao({
                                titulo: "Revogar credenciais",
                                mensagem: "Você precisará cadastrar novamente para emitir boletos via API. Deseja continuar?",
                                textoOk: "Revogar credenciais",
                                perigo: true,
                                onConfirm: async () => {
                                  setRevogando(true);
                                  try {
                                    await contasBancariasService.revogarApiConfig(contaSelecionada.id, apiConfig.banco || "Sicoob");
                                    setApiConfig(p=>({...p, clientId:"", clientSecret:"", clientSecretHint:""}));
                                    setApiTested(null);
                                    setConfirmacao(null);
                                    showBanner("success", "Credenciais revogadas com sucesso.");
                                  } catch(e){ setConfirmacao(null); showBanner("error", e?.message||"Erro ao revogar."); }
                                  setRevogando(false);
                                },
                              })}>
                              {revogando ? <span className="spinner-border spinner-border-sm me-1"/> : <i className="bi bi-shield-x me-1"/>}
                              Revogar
                            </button>
                          )}
                          {apiConfig.clientId && apiConfig.ambiente==="Homologacao" && (
                            <span style={{fontSize:12,color:"#D97706",fontWeight:600}}>
                              ⚠️ Em modo Sandbox — boletos não valem para pagamento real
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Guia de configuração — dinâmico por banco */}
                      <div style={{marginTop:20,background:"var(--bg-surface-alt)",borderRadius:10,padding:"14px 18px",fontSize:12,border:"1px solid var(--gray-200)"}}>
                        {(apiConfig.banco==="EFI"||apiConfig.banco==="364") ? (<>
                          <div style={{fontWeight:700,marginBottom:10,fontSize:13}}>📋 Como obter as credenciais na EFÍ Bank (Gerencianet)</div>
                          <ol style={{margin:0,paddingLeft:18,lineHeight:2.2}}>
                            <li>Acesse <a href="https://efipay.com.br" target="_blank" rel="noreferrer">efipay.com.br</a> e faça login na sua conta</li>
                            <li>No menu lateral, clique em <strong>API → Minhas Aplicações → Nova Aplicação</strong></li>
                            <li>Dê um nome (ex: <em>Horizon eCondo</em>) e ative os escopos <strong>Cobranças</strong> e <strong>PIX</strong></li>
                            <li>Copie o <strong>Client ID</strong> e o <strong>Client Secret</strong> gerados</li>
                            <li>Para PIX Dinâmico, preencha também o campo <strong>Chave PIX</strong> acima</li>
                            <li>Use <strong>Homologação</strong> para testes — nenhum pagamento real é processado</li>
                            <li>Em produção, acesse <strong>API → Certificados</strong> e gere o arquivo <code>.p12</code></li>
                          </ol>
                          <div style={{marginTop:10,background:"var(--bg-success-soft)",borderRadius:8,padding:"8px 12px",color:"#166534",fontSize:11}}>
                            💡 No sandbox da EFÍ, <strong>não é necessário</strong> preencher Agência, Conta ou Nº Contrato.
                          </div>
                        </>) : (<>
                          <div style={{fontWeight:700,marginBottom:10,fontSize:13}}>📋 Como obter as credenciais no Sicoob</div>
                          <ol style={{margin:0,paddingLeft:18,lineHeight:2.2}}>
                            <li>Acesse <a href="https://developers.sicoob.com.br" target="_blank" rel="noreferrer">developers.sicoob.com.br</a> com seu usuário e senha da cooperativa</li>
                            <li>Clique em <strong>Meus Apps → Criar Aplicação</strong></li>
                            <li>No produto, selecione <strong>Cobrança Bancária v3</strong></li>
                            <li>Copie o <strong>Client ID</strong> e <strong>Client Secret</strong> exibidos</li>
                            <li>Preencha a <strong>Agência</strong> (4 dígitos) e <strong>Conta</strong> sem dígito verificador</li>
                            <li>Inicie em <strong>Sandbox (Homologação)</strong> para validar antes de ir para Produção</li>
                          </ol>
                        </>)}
                      </div>
                    </div>
                  )}
                  {aba==="conciliacao"&&(
                    <div style={{padding:16}}>
                      <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"10px 14px",fontSize:12.5,color:"var(--primary)",marginBottom:16}}>
                        <i className="bi bi-info-circle me-2"/>Selecione as transações que foram confirmadas no extrato bancário e clique em <strong>Conciliar Selecionadas</strong>.
                      </div>
                      <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:12,flexWrap:"wrap"}}>
                        <div>
                          <label style={{fontSize:12,fontWeight:600,color:"var(--gray-600)",marginRight:8}}>Data:</label>
                          <input type="date" className="form-control form-control-sm d-inline-block" style={{width:"auto"}} value={dtConciliacao} onChange={e=>setDtConciliacao(e.target.value)}/>
                        </div>
                        <input className="form-control form-control-sm" style={{width:"auto",minWidth:180}}
                          placeholder="Buscar histórico ou sacado..."
                          value={filtroConc.busca}
                          onChange={e=>setFiltroConc(p=>({...p,busca:e.target.value}))}/>
                        <select className="form-select form-select-sm" style={{width:"auto"}} value={filtroConc.origem} onChange={e=>setFiltroConc(p=>({...p,origem:e.target.value}))}>
                          <option value="">Todas origens</option>
                          {origensConc.map(o => <option key={o} value={o}>{o}</option>)}
                        </select>
                        <select className="form-select form-select-sm" style={{width:"auto"}} value={filtroConc.tpMov} onChange={e=>setFiltroConc(p=>({...p,tpMov:e.target.value}))}>
                          <option value="">Déb/Créd</option>
                          <option value="Credito">Crédito</option>
                          <option value="Debito">Débito</option>
                        </select>
                        <button className="btn btn-outline-secondary btn-sm" onClick={carregarNaoConciliadas}><i className="bi bi-arrow-clockwise"/> Atualizar</button>
                        <button className="btn btn-success btn-sm ms-auto" onClick={handleConciliarLote} disabled={!selecionadas.length||conciliando}>
                          {conciliando?<span className="spinner-border spinner-border-sm me-1"/>:<i className="bi bi-check2-all me-1"/>}
                          Conciliar Selecionadas ({selecionadas.length})
                        </button>
                      </div>
                      {naoConciliadasFiltradas.length !== naoConciliadas.length && (
                        <div style={{fontSize:12,color:"var(--gray-500)",marginBottom:8}}>
                          Mostrando <strong>{naoConciliadasFiltradas.length}</strong> de {naoConciliadas.length} transações
                        </div>
                      )}
                      <div className="table-responsive">
                        <table className="table table-custom">
                          <thead><tr>
                            <th><input type="checkbox" checked={selecionadas.length===naoConciliadasFiltradas.length&&naoConciliadasFiltradas.length>0} onChange={()=>{
                              if (selecionadas.length === naoConciliadasFiltradas.length) setSelecionadas([]);
                              else setSelecionadas(naoConciliadasFiltradas.map(t=>t.id));
                            }}/></th>
                            <th>Data</th><th>Histórico</th><th>Sacado</th><th>Origem</th><th style={{textAlign:"right"}}>Valor</th><th>Status</th><th>Ações</th>
                          </tr></thead>
                          <tbody>
                            {naoConciliadasFiltradas.length===0?<tr><td colSpan={8} className="text-center py-4" style={{color:"var(--gray-400)"}}>{naoConciliadas.length===0 ? "✓ Nenhuma transação pendente de conciliação" : "Nenhuma transação corresponde aos filtros"}</td></tr>
                            :naoConciliadasFiltradas.map(t=>(
                              <tr key={t.id} style={{background:selecionadas.includes(t.id)?"#F0FDF4":""}}>
                                <td><input type="checkbox" checked={selecionadas.includes(t.id)} onChange={()=>toggleSelecionada(t.id)}/></td>
                                <td style={{fontSize:12.5}}>{fmtDt(t.dtTransacao)}</td>
                                <td style={{fontSize:13}}>{t.historico||"—"}</td>
                                <td style={{fontSize:12.5,color:"var(--gray-600)"}}>{t.sacado||"—"}</td>
                                <td><span style={{background:"var(--gray-100)",color:"var(--gray-600)",padding:"2px 7px",borderRadius:10,fontSize:11}}>{t.origem}</span></td>
                                <td style={{textAlign:"right",fontWeight:700,color:t.tpMovimento==="Credito"?"#166534":"#991B1B"}}>
                                  {t.tpMovimento==="Credito"?"+":"-"} {fmtMoeda(t.vlrTransacao)}
                                </td>
                                <td><span style={{...STATUS_STYLE[t.status],padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>{t.status}</span></td>
                                <td>
                                  <button className="btn btn-success btn-sm" style={{fontSize:11}} onClick={()=>handleConciliarUm(t.id)}>
                                    <i className="bi bi-check-lg"/> Conciliar
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* ── IMPORTAR CNAB ── */}
                  {aba==="cnab"&&(
                    <div style={{padding:16}}>
                      <div className="row g-3">
                        <div className="col-md-5">
                          <div className="form-section">
                            <div className="form-section-title"><i className="bi bi-upload"/> Importar Arquivo CNAB</div>
                            <div className="mb-3">
                              <label className="form-label">Formato do Arquivo</label>
                              <div className="d-flex gap-2">
                                {["CNAB240","CNAB400"].map(t=>(
                                  <button key={t} type="button" className={`btn flex-fill ${cnabTipo===t?"btn-primary":"btn-outline-secondary"}`} style={{fontSize:13}} onClick={()=>setCnabTipo(t)}>
                                    {t}
                                  </button>
                                ))}
                              </div>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Arquivo de Retorno</label>
                              <div style={{border:"2px dashed var(--gray-300)",borderRadius:8,padding:"24px 16px",textAlign:"center",cursor:"pointer",background:"var(--gray-50)"}} onClick={()=>fileRef.current?.click()}>
                                {cnabNome
                                  ? <><i className="bi bi-file-check text-success" style={{fontSize:28,display:"block"}}/><div style={{fontSize:13,fontWeight:600,color:"var(--gray-700)",marginTop:6}}>{cnabNome}</div></>
                                  : <><i className="bi bi-cloud-upload" style={{fontSize:28,display:"block",color:"var(--gray-400)"}}/><div style={{fontSize:13,color:"var(--gray-400)",marginTop:6}}>Clique para selecionar</div><div style={{fontSize:11,color:"var(--gray-300)"}}>Arquivos .RET, .TXT, .rem</div></>
                                }
                              </div>
                              <input ref={fileRef} type="file" accept=".txt,.ret,.rem,.RET,.TXT" style={{display:"none"}} onChange={handleArquivoCNAB}/>
                            </div>
                            <button className="btn btn-success w-100" onClick={handleImportarCNAB} disabled={!cnabConteudo||importando}>
                              {importando?<><span className="spinner-border spinner-border-sm me-2"/>Importando...</>:<><i className="bi bi-upload me-2"/>Importar</>}
                            </button>
                          </div>
                        </div>
                        <div className="col-md-7">
                          {resultCnab
                            ? <div className="form-section">
                                <div className="form-section-title"><i className="bi bi-clipboard-check"/> Resultado da Importação</div>
                                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
                                  {[
                                    {label:"Total de Linhas",val:resultCnab.totalLinhas,color:"var(--gray-700)"},
                                    {label:"Importadas",val:resultCnab.totalImportadas,color:"#166534"},
                                    {label:"Ignoradas (duplicadas)",val:resultCnab.totalIgnoradas,color:"#854D0E"},
                                    {label:"Erros",val:resultCnab.totalErros,color:"#991B1B"},
                                  ].map(item=>(
                                    <div key={item.label} style={{background:"var(--gray-50)",borderRadius:8,padding:"12px 16px"}}>
                                      <div style={{fontSize:22,fontWeight:700,color:item.color}}>{item.val}</div>
                                      <div style={{fontSize:12,color:"var(--gray-500)"}}>{item.label}</div>
                                    </div>
                                  ))}
                                </div>
                                <div style={{background:"var(--bg-success-soft)",borderRadius:8,padding:"12px 16px",fontSize:13,color:"#166534",fontWeight:600}}>
                                  <i className="bi bi-check-circle me-2"/>
                                  {resultCnab.message}
                                </div>
                                <button className="btn btn-outline-secondary btn-sm mt-3" onClick={()=>{ setResultCnab(null); setCnabConteudo(""); setCnabNome(""); if(fileRef.current) fileRef.current.value=""; }}>
                                  <i className="bi bi-arrow-counterclockwise me-1"/>Nova importação
                                </button>
                              </div>
                            : <div style={{textAlign:"center",padding:"60px 0",color:"var(--gray-400)"}}>
                                <i className="bi bi-file-earmark-arrow-up" style={{fontSize:48,display:"block",marginBottom:12}}/>
                                <p style={{fontSize:14}}>Selecione o arquivo e clique em Importar</p>
                                <p style={{fontSize:12}}>Formatos suportados: CNAB 240 e CNAB 400</p>
                              </div>
                          }
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
          }
        </div>
      </div>

      {/* Modais */}
      <ContaBancariaModal show={showContaModal} onClose={()=>setShowContaModal(false)} onSave={handleSaveConta}
        editData={editConta} saving={savingConta} idCondominio={idCondo} condominioNome={condoNome}/>
      <TransacaoModal show={showTransModal} onClose={()=>setShowTransModal(false)} onSave={handleSaveTrans}
        editData={editTrans} saving={savingTrans} idCondominio={idCondo} contaNome={contaSelecionada?.nmConta||""}/>
      <DeleteModal show={showDeleteConta} onClose={()=>setShowDeleteConta(false)} onConfirm={handleDeleteConta}
        itemName={deleteConta?.nmConta} loading={deletingConta}/>
      {showTransf && (
        <TransferenciaModal
          idCondominio={idCondo}
          onClose={()=>setShowTransf(false)}
          onSucesso={()=>{ setShowTransf(false); carregarContas(); if (aba==="extrato") carregarTransacoes(); }}
        />
      )}

      {/* Confirmações genéricas (substitui window.confirm) */}
      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk || "Confirmar"}
          textoCancelar={confirmacao.textoCancelar || "Cancelar"}
          perigo={!!confirmacao.perigo}
          onConfirm={confirmacao.onConfirm}
          onCancel={()=>setConfirmacao(null)}
        />
      )}
    </div>
  );
}
